module.exports = __webpack_public_path__ + "static/media/entregarinju9.6927fde4.webp";